var _ = require('lodash');

export const canBypassTicketRequirement = (addOn, startAtAddOns) => {
  return addOn.disable_require_ticket_type_with_direct_link && startAtAddOns;
};

export const requiredAddOnMet = (addOn, addOns, userContext) => {
  if(!addOn.require_add_on){
    return true;
  }

  var requiredIds = addOn.required_add_on_ids || [];

  return addOns.some((ao) => requiredIds.includes(ao.id) && ao.quantity > 0)
    || ((userContext && userContext.tickets) || []).some((t) => requiredIds.includes(t.add_on_id));
};

// Repeats so a chain (C needs B needs A) clears all the way down when A leaves the cart.
export const clearUnmetAddOnRequirements = (addOns, userContext) => {
  var cleared = addOns.map((addOn) => (
    addOn.quantity > 0 && !requiredAddOnMet(addOn, addOns, userContext)
      ? Object.assign({}, addOn, {quantity: 0})
      : addOn
  ));

  return cleared.some((addOn, i) => addOn !== addOns[i])
    ? clearUnmetAddOnRequirements(cleared, userContext)
    : addOns;
};

export const eligibleOwnedTicketTypes = (addOn, userContext) => {
  if(!addOn.require_ticket_type){
    return [];
  }

  var userTickets = (userContext.tickets || []);
  var addOnTickets = userTickets.filter((t) => t.add_on_id === addOn.id);
  var admissionTickets = userTickets.filter((t) => addOn.ticket_type_ids.includes(t.ticket_type_id));

  var addOnsCount = addOn.seating_chart_category_key && addOn.seating_chart_category_key.length > 0 ? (
      0
    ) : addOnTickets.length > admissionTickets.length ? (
      admissionTickets.length
    ) : (
      addOnTickets.length
    );

  var lastIndex = (admissionTickets.length - addOnsCount);
  var slicedAdmissionTickets = admissionTickets.slice(0, lastIndex);
  var groupedByTicketTypeId = _.groupBy(slicedAdmissionTickets, "ticket_type_id");

  return Object.keys(groupedByTicketTypeId).map((ticketTypeId) => {
    return {
      id: parseInt(ticketTypeId),
      quantity: groupedByTicketTypeId[ticketTypeId].length
    }
  });
};

export const addOnQuantityOptions = (addOn, ticketTypes, userContext, startAtAddOns) => {
  var useQuantityOptions = (
    !addOn.require_ticket_type
      || (
        addOn.seating_chart_category_key
          && addOn.seating_chart_category_key.length > 0
      ) || canBypassTicketRequirement(addOn, startAtAddOns)
  );

  if(useQuantityOptions){
    return addOn.current_quantity_options || addOn.quantity_options;
  } else {
    var ownedTicketTypes = eligibleOwnedTicketTypes(addOn, userContext);
    var buyingAndOwnedTicketTypes = ticketTypes.concat(ownedTicketTypes);
    var groupedTicketTypes = _.groupBy(buyingAndOwnedTicketTypes, "id");

    var allTicketTypes = Object.keys(groupedTicketTypes)
      .map((ticketTypeId) => {
        var quantity = groupedTicketTypes[ticketTypeId]
          .reduce((sum, tt) => {
            return sum + (tt.quantity || 0);
          }, 0);

        return {
          id: parseInt(ticketTypeId),
          quantity: quantity
        }
      });

    var ticketsOrdered = allTicketTypes
      .filter((tt) => addOn.ticket_type_ids.includes(tt.id))
      .filter((tt) => tt.quantity && tt.quantity > 0)
      .reduce((sum, tt) => {
        return sum + tt.quantity;
      }, 0);

    // Mirrors AddOn#quantity_options_for_user: the ticketsOrdered > 0 guard preserves the eligibility contract — don't simplify away.
    if (ticketsOrdered > 0 && addOn.limit_quantity_to_admission_count === false) {
      return addOn.current_quantity_options || addOn.quantity_options;
    }

    var maximumAllowed = (
      addOn.maximum_per_order < ticketsOrdered ? addOn.maximum_per_order : ticketsOrdered
    );

    return addOn.quantity_options.filter((i) => i <= maximumAllowed);
  }
};
